import React from 'react';
import { Banner, Layout, Paragraph, ParagraphHeader } from '@axiom/ui';
import type { CandidateEngagementDetails } from '@axiom/validation';
import { Link } from 'react-router';

import { EnvUtil } from '../../utils/env-util';

export type EngagementsViewStateBannerInterviewingExpectedExternalProps = {
  engagement: CandidateEngagementDetails;
  name?: string;
};

export const EngagementsViewStateBannerInterviewingExpectedExternal: React.FC<
  EngagementsViewStateBannerInterviewingExpectedExternalProps
> = ({
  engagement,
  name = 'ENGAGEMENTS_VIEW_STATE_BANNER_INTERVIEWING_EXPECTED_EXTERNAL',
}) => {
  return (
    <Banner name={name} type="critical" impact="high">
      <Layout direction="vertical" verticalGutter="24px">
        <ParagraphHeader name="INTERVIEWING_EXPECTED_EXTERNAL_HEADER">
          Next Step: Upcoming interview
        </ParagraphHeader>
        <Paragraph name="INTERVIEWING_EXPECTED_EXTERNAL_MESSAGE_1">
          If details for your upcoming interview with{' '}
          {engagement.opportunity.accountName ?? 'the client'} aren't visible
          here yet, the interview may be in scheduling or was scheduled directly
          via email. Please keep your{' '}
          <Link
            to="../../profile/interview-availability"
            data-test="INTERVIEW_LINK"
          >
            interview availability calendar
          </Link>{' '}
          up to date and check back often or reach out to the opportunity
          contact for more information.
        </Paragraph>
        <Paragraph name="INTERVIEWING_EXPECTED_EXTERNAL_MESSAGE_2">
          Go ahead and start preparing for your interview using{' '}
          <a href={EnvUtil.interviewGuideUrl} rel="noreferrer" target="_blank">
            Axiom's Interview Preparation Guidelines
          </a>
          .
        </Paragraph>
      </Layout>
    </Banner>
  );
};
